export const opacityIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M10 0S2 8.166 2 12a8 8 0 1 0 16 0c0-4.17-8-12-8-12zm6 12H4c0-2.782 6-9.5 6-9.5s6 6.66 6 9.5z"/></svg>`,
  name: 'opacity',
};
